// TDS2 SHIM — replace with @salesforce/trailhead-ui ThinkingIndicator when TDS2 lands.
// Mirrors the prototype's `TrailheadThinkingIndicator`
// (headless-agent-creation/src/pages/UnitBuildAgent.tsx).
//
// Renders a stacked, progressive thinking trace: as each new label is added
// to `labels`, a new line appears below the previous one. The latest line
// shimmers electric-blue; prior lines settle into a static, slightly-blue
// gradient. Each line is keyed on its text so React only animates the new
// one in — old lines hold their position.
//
// Driver: pass the full list of stage labels observed so far. The
// ChatContainer derives this from `agentStages` via `stagesToTraceSteps`.
import React from 'react';
import PropTypes from 'prop-types';

export default function ThinkingIndicator({ labels, ariaLabel }) {
  if (!labels || labels.length === 0) return null;
  const lastIdx = labels.length - 1;

  return (
    <div className="tds2-agentforce-thinking" role="status" aria-live="polite">
      <div
        className="tds2-agentforce-thinking__trace"
        aria-label={ariaLabel || 'Agent thinking'}
      >
        {labels.map((label, idx) => {
          const isCurrent = idx === lastIdx;
          const className = 'tds2-agentforce-thinking__line' +
            (isCurrent ? ' tds2-agentforce-thinking__line--current' : '');
          return (
            <div key={label} className={className}>
              {label}
            </div>
          );
        })}
      </div>
    </div>
  );
}

ThinkingIndicator.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  ariaLabel: PropTypes.string,
};
